import React from 'react';
import { Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import logo from "../../assets/RoyalCover.png";
const styles = StyleSheet.create({
    titleContainer: {
        marginTop: 100,
        display: "flex",
        justifyContent: "center", // Centers children (Image) horizontally
        alignItems: "center",
    },
    reportTitle: {
        fontSize: 10,
        textAlign: 'center',
        textTransform: 'uppercase',
    },
    logo: {
        width: "160px",
    },
});

const InvoiceThankYouMsg = () => (
    <View style={styles.titleContainer}>
        {/* <Text style={styles.reportTitle}>*** This is a system generated letter and no signature is required. ***</Text> */}
        <Image style={styles.logo} src={logo} />
    </View>
);

export default InvoiceThankYouMsg;